import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  useLazyReviewsListQuery,
  useLazyReviewRoomSharingListQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import AllReview from "./AllReview";
import RoomSharing from "./RoomSharing";

const ReviewsList = () => {
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);
  const [tab, setTab] = useState(1);
  const [resolvePage, setRoomSharingPage] = useState(1);
  const [supportPage, setReviewsPage] = useState(1);
  const [searchReviews, setsearchReviews] = useState("");
  const [searchRoomSharing, setsearchRoomSharing] = useState("");
  const [rowReviews, setrowReviews] = useState(10);
  const [rowRoomSharing, setrowRoomSharing] = useState(10);
  const [listReviews, setlistReviews] = useState([]);
  const [listRoomSharing, setlistRoomSharing] = useState([]);
  const [reviewsCount, setreviewsCount] = useState(1);
  const [roomSharingCount, setroomSharingCount] = useState(1);
  const [paginationReviews, setPagonationSupport] = useState({});
  const [paginationRoomSharing, setPagonationResolve] = useState({});
  const [toDateReviews, settoDateReviews] = useState("");
  const [fromDateReviews, setfromDateReviews] = useState("");
  const [toDateRoomSharing, settoDateRoomSharing] = useState("");
  const [fromDateRoomSharing, setfromDateRoomSharing] = useState("");

  // RTK QUERY
  const [reviewListApi] = useLazyReviewsListQuery();
  const [roomSharingListApi] = useLazyReviewRoomSharingListQuery();

  const getReviewsList = (search_, row_value, from_date, to_date) => {
    let params = `?page=${supportPage}`;
    dispatch(saveLoader(true));

    if (search_) {
      params += `&search=${search_}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }

    setrowReviews(row_value);
    setsearchReviews(search_);
    setfromDateReviews(from_date);
    settoDateReviews(to_date);
    reviewListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setlistReviews(res?.reviews);
        setreviewsCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationSupport(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const getRoomSharingList = (search_, row_value, from_date, to_date) => {
    let params = `?page=${resolvePage}`;

    if (search_) {
      params += `&search=${search_}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }

    setrowRoomSharing(row_value);
    setsearchRoomSharing(search_);
    setfromDateRoomSharing(from_date);
    settoDateRoomSharing(to_date);
    dispatch(saveLoader(true));
    roomSharingListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setlistRoomSharing(res?.room_sharing_reviews);
        setroomSharingCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationResolve(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getReviewsList(searchReviews, rowReviews, fromDateReviews, toDateReviews);
  }, [supportPage]);

  useEffect(() => {
    getRoomSharingList(searchRoomSharing, rowRoomSharing);
  }, [resolvePage]);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"review-list"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="nav-user mb-4" style={{ overflow: "auto" }}>
            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 1 ? "pre-active" : ""
                }`}
                onClick={() => setTab(1)}
              >
                All Review
              </button>
            </div>

            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 2 ? "pre-active" : ""
                }`}
                onClick={() => setTab(2)}
              >
                Room Sharing
              </button>
            </div>
          </div>
          <div>
            {tab == 1 && (
              <AllReview
                getReviewsList={getReviewsList}
                searchReviews={searchReviews}
                setReviewsPage={setReviewsPage}
                getRoomSharingList={getRoomSharingList}
                reviewsCount={reviewsCount}
                listReviews={listReviews}
                paginationReviews={paginationReviews}
                rowReviews={rowReviews}
                fromDateReviews={fromDateReviews}
                toDateReviews={toDateReviews}
              />
            )}

            {tab == 2 && (
              <RoomSharing
                getRoomSharingList={getRoomSharingList}
                searchRoomSharing={searchRoomSharing}
                setRoomSharingPage={setRoomSharingPage}
                roomSharingCount={roomSharingCount}
                listRoomSharing={listRoomSharing}
                paginationRoomSharing={paginationRoomSharing}
                rowRoomSharing={rowRoomSharing}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReviewsList;
